import { render, staticRenderFns } from "./StaticExample.vue?vue&type=template&id=71624dba&scoped=true"
import script from "./StaticExample.vue?vue&type=script&lang=js"
export * from "./StaticExample.vue?vue&type=script&lang=js"
import style0 from "./StaticExample.vue?vue&type=style&index=0&id=71624dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71624dba",
  null
  
)

export default component.exports